var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"gallery"},[_c('image-gallery',{attrs:{"big":true,"gallery":_vm.normalizeData,"type":"gallery","data-aos":"fade-in"}}),_c('background-image')],1)}
var staticRenderFns = []

export { render, staticRenderFns }